import type { PlateStatus } from "@bi/types";

/** Pill de status de placa (Ótimo/Bom/Atenção/Crítico) para tabelas de frota. */
const STYLES: Record<PlateStatus, { badge: string; label: string }> = {
  otimo:   { badge: "badge-green", label: "Ótimo" },
  bom:     { badge: "badge-green", label: "Bom" },
  atencao: { badge: "badge-amber", label: "Atenção" },
  critico: { badge: "badge-red",   label: "Crítico" },
};

export function StatusPill({ status }: { status: PlateStatus }) {
  const s = STYLES[status];
  return <span className={s.badge}>{s.label}</span>;
}
